import { render, staticRenderFns } from "./issueListManage.vue?vue&type=template&id=c725f824&scoped=true&"
import script from "./issueListManage.vue?vue&type=script&lang=js&"
export * from "./issueListManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c725f824",
  null
  
)

export default component.exports